import React from "react";
import { cn } from "@/lib/utils";
import TextCardToggle from "@/components/ui/text-card-toggle";

type ColumnData = { title?: string; description?: string | React.ReactNode };

export interface TwoColumnTextProps {
  id?: string;
  className?: string;
  left?: ColumnData;
  right?: ColumnData;
}

const TwoColumnText: React.FC<TwoColumnTextProps> = ({
  id = "two-column-text",
  className,
  left = {
    title: "What is Lorem Ipsum?",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
  right = {
    title: "What is Lorem Ipsum?",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  },
}) => {
  return (
    <section
      id={id}
      aria-label={id}
      className={cn("bg-primary-100", className)}
    >
      <div className="mx-auto grid max-w-lg grid-cols-1 gap-6 px-[14px] pb-8 pt-6 md:gap-8 md:px-6 md:pb-10 md:pt-6 lg:grid-cols-2 lg:gap-16 lg:px-3 lg:py-12">
        {left && (
          <TextCardToggle
            variant="mobile"
            className="col-span-2 flex w-full lg:col-span-1"
            containerClassName="gap-2 lg:gap-4"
            titleClassName="font-montserrat text-secondary-500 text-subheading-3-500 lg:text-heading-4"
            title={left.title}
            contentClassName="text-neutral-500 md:!h-fit body-1-400 font-roboto"
            defaultCollapsed={true}
            collapsedHeight={144}
            toggleClassName="md:hidden text-secondary-500"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: left.description ?? "",
              }}
            />
          </TextCardToggle>
        )}
        {right && (
          <TextCardToggle
            variant="mobile"
            className="col-span-2 flex w-full lg:col-span-1"
            containerClassName="gap-2 lg:gap-4"
            titleClassName="font-montserrat text-secondary-500 text-subheading-3-500 lg:text-heading-4"
            title={right.title}
            contentClassName="text-neutral-500 md:!h-fit body-1-400 font-roboto"
            defaultCollapsed={true}
            collapsedHeight={144}
            toggleClassName="md:hidden text-secondary-500"
          >
            <div
              dangerouslySetInnerHTML={{
                __html: right.description ?? "",
              }}
            />
          </TextCardToggle>
        )}
      </div>
    </section>
  );
};

export default TwoColumnText;
